import React from 'react';
import { Link } from 'react-router-dom';
import NavigationComponent from '../../commonComponents/util/NavigationComponent';
import HoverTableRow from '../../commonComponents/util/HoverTableRow';

export default class CampaignListParticipantsTableRow extends NavigationComponent {

    render() {
        const { applicantId, addressDisplay, displayName, orgEmployment, phoneNumber = [] } = this.props.participant;
        const { campaignListId } = this.props;
        return (
            <HoverTableRow
            onClick={this.pushRouteWithProps.bind(this,
                `/recipient-accounts/${applicantId}`,
                {
                    prevPage: `${this.props.campaignListName} Campaign List`,
                    campaignListId,
                    recipientId: applicantId
                })}
                >
                <td data-label="Name">
                    <Link
                        className="bold-text"
                        to={`/recipient-accounts/${applicantId}`}>
                        {displayName}
                    </Link>
                </td>
                <td data-label="Phone">
                    <p>{phoneNumber.join(' | ')}</p>
                </td>
                <td data-label="Address">
                    <p>{addressDisplay}</p>
                </td>
                {this.props.isExternalOrgCampaignList && <td data-label="Position">
                    <p>{orgEmployment}</p>
                </td>}
                {this.props.managePermission && <td data-label="Delete" className="delete-table-cell">
                    <i className="icon-trash trash-hover input" onClick={this.props.removeParticipant.bind(this, this.props.participant)}></i>
                </td>}
            </HoverTableRow>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/campaignComponents/campaignListDetails/CampaignListParticipantsTableRow.jsx